import request from '@/utils/axios.js'

// 登录
export function login (data) {
  return request({
    url: '/auth/login/token',
    method: 'post',
    params: data
  })
}

// 获取验证码
export function SendMessage (data) {
  return request({
    url: '/message/openAPI/smsCode/send',
    method: 'post',
    data: data
  })
}

// 用户注册
export function createMember (data, username, code) {
  return request({
    url: '/user/createMember?username=' + username + '&code=' + code,
    method: 'put',
    data: data
  })
}

// 忘记密码
export function forgetPassword (data, username, code) {
  return request({
    url: '/user/ignoreLogin/mobileAPI/forgetPassword/?username=' + username + '&code=' + code,
    method: 'post',
    data: data
  })
}

// 便捷青岛注册
export function apiSendCode (data) {
  return request({
    // url: '/userAPI/app/user/captcha/send',
    url: '/usercenter/userAPI/user/captcha/send',
    method: 'post',
    data: data
  })
}

export function apiRegister (data) {
  return request({
    // url: '/userAPI/app/user/register/open/H5',
    url: '/usercenter/userAPI/user/register',
    method: 'post',
    data: data
  })
}
